<template>
  <v-dialog
    v-model="localDialog"
    width="80%"
    @update:modelValue="updateDialog"
    transition=""
    persistent
    :open-delay="0"
    :close-delay="0"
  >
    <v-card>
      <v-card-title class="text-h6">
        <span>User Permission</span>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-form @submit.prevent="submit" ref="UserSetup">
          <v-row>
            <v-col lg="4" md="4" cols="12">
              <v-autocomplete
                label="Select Company"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="company_id.value.value"
                :items="getCompanyList.filter(item=> item.status == 1)"
                :item-title="(item) => `${item.name} - ${item.code}`"
                item-value="id"
                :error-messages="company_id.errorMessage.value"
                clearable
                autocomplete="off"
              ></v-autocomplete>

            </v-col>

            <v-col lg="4" md="4" cols="12">
              <v-autocomplete
                label="Select Branch"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="branch_id.value.value"
                :items="getBranchList.filter(item => item.company_id == this.company_id.value.value)"
                :item-title="(item) => `${item.name} - ${item.code}`"
                item-value="id"
                :error-messages="branch_id.errorMessage.value"
                clearable
                autocomplete="off"
              ></v-autocomplete>
            </v-col>

            <v-col lg="3" md="3" cols="11">
              
              <v-autocomplete
                label="Select Role"
                variant="outlined"
                density="compact"
                bg-color="grey-lighten-4"
                v-model="role_id.value.value"
                :items="getRoleList.filter(item => item.branch_id == this.branch_id.value.value)"
                :item-title="(item) => `${item.name} - ${item.code}`"
                item-value="id"
                :error-messages="role_id.errorMessage.value"
                clearable
                autocomplete="off"
              ></v-autocomplete>
            </v-col>

            <v-col cols="1">
              <v-btn icon="mdi mdi-plus" block color="primary" size="small" rounded="0" @click="addCart" ></v-btn>
            </v-col>
          </v-row>

           <!-- Cart Table -->
              <v-row>
                  <v-col cols="12">
                      <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">
                          <thead>
                            <tr>
                                <th class="text-center" style="width:7%">SL</th>
                                <th class="text-left" style="width:30%">Company Name</th>
                                <th class="text-left" style="width:30%">Branch Name</th>
                                <th class="text-left" style="width:25%">Role Name</th>
                                <th class="text-center" style="width:8%">Action</th>
                            </tr>
                          </thead>
                          <tbody>

                              <tr v-for="(item,index) in cart" v-if="cart.length > 0">
                                  <td class="text-center">{{ index + 1 }}</td>
                                  <td  class="text-left" style="white-space: normal;">{{ item.company_name }}</td>
                                  <td  class="text-left">{{ item.branch_name }}</td>
                                  <td  class="text-left">{{ item.role_name }}</td>
                                  <td  class="text-center">
                                      <v-icon
                                          size="small"
                                          color="red"
                                          class="delete-button"
                                          @click="removeFromCart(index)">
                                          mdi-delete
                                      </v-icon>
                                  </td>
                              </tr>

                              <tr v-else-if="loading == true"><td colspan="5" class="text-center"><v-skeleton-loader type="heading" :loading="loading"/></td></tr>
                              <tr v-else><td colspan="5" class="text-center text-red">You have no permission</td></tr>
                          </tbody>
                      </v-table>
                  </v-col>
              </v-row>
           <!-- Close Cart Table -->

          <v-divider></v-divider>
          <v-card-actions>
            <v-layout class="justify-end">
              <v-btn
                class="bg-red"
                variant="flat"
                type="reset"
                @click="closeDialog"
                >Close</v-btn
              >
              <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                Save
              </v-btn>
            </v-layout>
          </v-card-actions>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useField, useForm } from 'vee-validate'
import * as yup from 'yup'
import { toast } from 'vue3-toastify'
import { fileServerUrl } from "@/store/api";

export default {
  name: 'UserSetup',
  props: {
    permissionDialog: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Object,
      default: {
        id: '',
      },
    }
  },
  data() {
    return {
      localDialog: this.permissionDialog,
      id: '',
      loading: false,
      cart: [],
    }
  },
  computed: {
    getCompanyList() {
      return this.$store.getters.getCompanyList;
    },
    getBranchList() {
      return this.$store.getters.getBranchList;
    },
    getRoleList() {
      return this.$store.getters.getRoleList;
    },
    
  },
  watch: {
    permissionDialog(val) {
      this.localDialog = val
    },
    localDialog(val) {
      this.$emit('update:permissionDialog', val)
    },
    data: {
      handler(newData) {
        this.resetForm({ errors: {}, touched: {} });
        this.id.setValue(newData.id || '', false);
      },
      deep: true
    },

  },
  created(props) {
    console.log('Mounted User Permission Component',props);
    if(this.$store.getters.getCompanyList.length == 0){this.$store.dispatch('getCompanyList')};
    if(this.$store.getters.getBranchList.length == 0){this.$store.dispatch('getBranchList')}
    if(this.$store.getters.getRoleList.length == 0){this.$store.dispatch('getRoleList')}
  },
  methods: {
    updateDialog(val) {
      this.$emit('update:permissionDialog', val)
    },
    closeDialog() {
      this.$emit('update:permissionDialog', false);
      this.cart = [];
    },
    addCart(){
            let cartInd = this.cart.findIndex(p => p.company_id == this.company_id.value.value && p.branch_id == this.branch_id.value.value && p.role_id == this.role_id.value.value);
            if(this.company_id.value.value == null || this.branch_id.value.value == null || this.role_id.value.value == null){
              toast.error('Please select all fields');
              return false;
            }
            if(cartInd > -1){
              toast.error('Permission exists in cart');
                this.cartReset();
              return false;
            }

            let company = this.getCompanyList.find(item => item.id == this.company_id.value.value);
            let branch = this.getBranchList.find(item => item.id == this.branch_id.value.value);
            let role = this.getRoleList.find(item => item.id == this.role_id.value.value);

            let permission = {
                company_id: this.company_id.value.value,
                company_name: company.name,
                branch_id: this.branch_id.value.value,
                branch_name: branch.name,
                role_id: this.role_id.value.value,
                role_name: role.name,
            }

            this.cart.push(permission);
            this.$nextTick(()=>{
              this.cartReset();
            })
    },
    removeFromCart(index){
        if(confirm('Are You Sure?')){
            this.cart.splice(index, 1);
        }
    },
    cartReset(){             
        this.company_id.value.value = null ;
        this.branch_id.value.value = null ;
        this.role_id.value.value = null ;  
    },
  },
  setup(props, { emit }){
    const { handleSubmit, resetForm} = useForm();

    const company_id = useField('company_id');
    const branch_id = useField('branch_id');
    const role_id = useField('role_id');
    const user_id = useField('user_id');
    const cart  =  ref([]);
    const loading  = ref('');
    const store = useStore();

    watch(
      () => props.permissionDialog,
      (val) => {
        if (val) {
          // এখানে আপনার API call দিন
          // উদাহরণ:
          loading.value = true;
          store.dispatch('getUserPermission', {user_id: props.userId.id})
            .then(response => {
              loading.value = false;
              cart.value = response.data.data;
              company_id.value.value = null;
              branch_id.value.value = null;
              role_id.value.value = null;
            })
            .catch(error => {
              loading.value = false;
            });
        }
      }
    );

    watch(() => company_id.value.value, () => {
      branch_id.value.value = null;
      role_id.value.value = null;
    });

    watch(() => branch_id.value.value, () => {
      role_id.value.value = null;
    });

    const submit = handleSubmit((values) => {

        var carts = cart.value;

        if(carts.length == 0){
            toast.error('please add at least one permission');
            return false;
        }
        values.cart = carts;
        values.user_id = props.userId.id;
        store.dispatch("saveUserRolePermission", values)
            .then((response) => {
                emit('update:permissionDialog', false);
                toast.success(response.data.message);
            })
            .catch((error) => {            
                toast.error(error.response.data.message);          
            })
    });
    return {
      submit,
      company_id,
      branch_id,
      role_id,
      cart,
      resetForm,
      loading
    }
  },
  mounted() {

  }
}
</script>

